import graphql from "babel-plugin-relay/macro";
import { isPast } from "date-fns";
import { readInlineData } from "react-relay";

import { convertDateStringToObj } from "@whoosh/utilities/src/dates";

import { packageOrderNeedsPayment_order$key } from "./__generated__/packageOrderNeedsPayment_order.graphql";

export const packageOrderNeedsPayment = (
  memberPackageRef?: packageOrderNeedsPayment_order$key | null
) => {
  const order = readInlineData(
    packageOrderNeedsPaymentFragmentString,
    memberPackageRef
  );

  if (!order?.packageDueDate) return false;

  const dueDate = convertDateStringToObj(order.packageDueDate);

  return order.status === "OPEN" && isPast(dueDate);
};

const packageOrderNeedsPaymentFragmentString = graphql`
  fragment packageOrderNeedsPayment_order on Order @inline {
    status
    packageDueDate
  }
`;
